import React, { useContext, useEffect, useState, memo } from "react";
import {
  Card,
  CardContent,
  Divider,
  IconButton,
  NativeSelect,
  Tooltip,
  CardHeader,
  Box,
  FormControl,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import ArchiveIcon from "@mui/icons-material/Archive";
import { blue, purple } from "@mui/material/colors";
import DataContext from "../../context/DataContext";
import { useConfirm } from "material-ui-confirm";
import { useToasts } from "react-toast-notifications";
import { useRef } from "react";

const ClientTable = memo(({ setName, setClientId }) => {
  let {
    clients,
    archivedClients,
    setArchivedClients,
    del,
    APIData,
    positions,
    archivedPositions,
    setPositions,
    setArchivedPositions,
    setClients,
    addObj,
  } = useContext(DataContext);

  const { addToast } = useToasts();

  const confirm = useConfirm();

  const columnsArchived = [
    {
      field: "name",
      headerName: "Client",
      description: "Client name",
      type: "string",
      // width: 130,
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.name}>
            <span>{params.row.name}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "date_modified",
      headerName: "Last Modified",
      description: "Date since last modified",
      type: "dateTime",
      // width: 160,
      headerAlign: "center",
      align: "center",
      flex: 1,
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      // width: 140,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: (params) => {
        const handleDeleteClick = () => {
          confirm({
            description: "Deleting a client will delete all related positions.",
          })
            .then(() => {
              //Delete object with id
              del(params.row.id, true, true);

              addToast(`Client '${params.row.name}' deleted successfully`, {
                appearance: "success",
              });

              // APIData.delete(`/client/${params.row.id}/`)
              //   .then(() => {
              //     addToast(`Client '${params.row.name}' deleted successfully`, {
              //       appearance: "success",
              //     });
              //     del(params.row.id, true, true);
              //     //must delete all positions
              //   })
              //   .catch((error) => {
              //     addToast(error.message, { appearance: "error" });
              //     console.error(
              //       "Could not delete client id:",
              //       params.row.id,
              //       error
              //     );
              //   });
            })

            .catch((reject) => {});
        };

        const handleUnarchiveClick = () => {
          confirm({
            description: `Proceed to unarchive client '${params.row.name}'?`,
          })
            .then(() => {
              let item = archivedClients.filter(
                (client) => client.id === params.row.id
              )[0];
              item["archived"] = false; //set archived to false

              item.date_modified = new Date().toLocaleString();
              addObj(item, true); //add to client

              del(params.row.id, true, true); //delete from archived clients

              addToast(`Client '${params.row.name}' unarchived successfully`, {
                appearance: "success",
              });

              // APIData.patch(`/client/${params.row.id}/`, item)
              //   .then((res) => {
              //     addToast(
              //       `Client '${params.row.name}' unarchived successfully`,
              //       { appearance: "success" }
              //     );
              //     del(params.row.id, true, true); //delete from archived clients
              //     var c = res.data;
              //     c.date_modified = new Date(res.data.date_modified);
              //     addObj(c, true); //add to client

              //   })
              //   .catch((error) => {
              //     addToast(error.message, { appearance: "error" });
              //     console.error("could not un archive position", error);
              //   });
            })
            .catch((reject) => {});
        };

        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
          >
            <div>
              <Tooltip title="Unarchive">
                <IconButton color="secondary" onClick={handleUnarchiveClick}>
                  <UnarchiveIcon style={{ color: purple[500] }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton color="secondary" onClick={handleDeleteClick}>
                  <DeleteIcon style={{ color: blue[500] }} />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        );
      },
    },
  ];

  const columns = [
    {
      field: "name",
      headerName: "Client",
      description: "Client name",
      type: "string",
      // width: 130,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Tooltip title={params.row.name}>
            <span>{params.row.name}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "date_modified",
      headerName: "Last Modified",
      description: "Date since last modified",
      type: "dateTime",
      // width: 160,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      // width: 140,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        //update will be done in clientform
        const handleEditClick = () => {
          let item = clients.filter((client) => client.id === params.row.id)[0];

          setName(item.name);
          setClientId(item.id);
        };

        const handleDeleteClick = () => {
          confirm({
            description: "Deleting a client will delete all related positions.",
          })
            .then(() => {
              //Delete client with id
              addToast(`Client '${params.row.name}' deleted successfully`, {
                appearance: "success",
              });
              del(params.row.id, false, true);

              // APIData.delete(`/client/${params.row.id}/`)
              //   .then(() => {
              //     addToast(`Client '${params.row.name}' deleted successfully`, {
              //       appearance: "success",
              //     });
              //     del(params.row.id, false, true);
              //     //the above deletes all positions with that client
              //   })
              //   .catch((error) => {
              //     addToast(error.message, { appearance: "error" });
              //     console.error(
              //       "Could not delete client id:",
              //       params.row.id,
              //       error
              //     );
              //   });
            })
            .catch((rej) => {});
        };

        const handleArchiveClick = async () => {
          confirm({
            description:
              "Archiving a client will archive all related positions",
          })
            .then(() => {
              let item = clients.filter(
                (client) => client.id === params.row.id
              )[0];
              item["archived"] = true;

              addToast(`Client '${params.row.name}' archived successfully`, {
                appearance: "success",
              });

              //remove from clients
              var arr = clients.filter((client) => client.id !== params.row.id);
              setClients(arr);

              //add to archived clients
              item.date_modified = new Date().toLocaleString();
              setArchivedClients([...archivedClients, item]); //add to archived clients

              //archive all positions
              //move to archive
              setArchivedPositions(
                [...archivedPositions].concat(
                  positions.filter((pos) => pos.client === params.row.id)
                )
              );
              //remove from positions
              setPositions(
                positions.filter((pos) => pos.client !== params.row.id)
              );

              // APIData.patch(`/client/${params.row.id}/`, item)
              //   .then((res) => {
              //     //remove from clients
              //     var arr = clients.filter(
              //       (client) => client.id !== params.row.id
              //     );
              //     setClients(arr);

              //     //add archived to archived clients
              //     var c = res.data;
              //     c.date_modified = new Date(res.data.date_modified);
              //     setArchivedClients([...archivedClients, c]); //add to archived clients

              //     //archive all positions
              //     //move to archive
              //     setArchivedPositions(
              //       [...archivedPositions].concat(
              //         positions.filter((pos) => pos.client === params.row.id)
              //       )
              //     );
              //     //remove from positions
              //     setPositions(
              //       positions.filter((pos) => pos.client !== params.row.id)
              //     );
              //   })
              //   .catch((error) => {
              //     addToast(error.message, { appearance: "error" });
              //     console.error("could not un archive position", error);
              //   });
            })
            .catch((rej) => {});
        };

        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
          >
            <div>
              <Tooltip title="Edit">
                <IconButton color="secondary" onClick={handleEditClick}>
                  <EditIcon style={{ color: blue[500] }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Archive">
                <IconButton color="secondary" onClick={handleArchiveClick}>
                  <ArchiveIcon style={{ color: blue[500] }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton color="secondary" onClick={handleDeleteClick}>
                  <DeleteIcon style={{ color: blue[500] }} />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        );
      },
    },
  ];

  const [subChart, setSubChart] = useState("most-important");
  let firstClick = useRef(true);

  //change is for uncarchive to archive
  const handleChange = (value) => {
    // if (firstClick.current) {
    //   //call APIData
    //   APIData.get("/client/", { params: { archived: true } })
    //     .then((res) => {
    //       let carr = res.data.map((client) => {
    //         var d = client.date_modified;
    //         return { ...client, date_modified: new Date(d) };
    //       });
    //       setArchivedClients(carr);
    //       firstClick.current = false;
    //     })
    //     .catch((error) => {
    //       //logout
    //       console.error(error);
    //       firstClick.current = true;
    //     });
    // }
    setSubChart(value);
  };

  return (
    <Card
      // sx={{ height: 400, width: "100%" }}
      variant="outlined"
      padding={1}
    >
      <CardHeader
        action={
          <Box sx={{ mr: 2 }}>
            <FormControl fullWidth color="secondary">
              <NativeSelect
                defaultValue={"most-important"}
                onChange={(e) => handleChange(e.target.value)}
              >
                <option value={"most-important"}>Clients</option>
                <option value={"overview"}>Archived</option>
              </NativeSelect>
            </FormControl>
          </Box>
        }
        titleTypographyProps={{ variant: "h6" }}
        title="Client Data"
      />
      <Divider />
      <CardContent
      // sx={{ height: "100%", width: "100%" }}
      >
        <div style={{ height: 300, width: "100%" }}>
          {subChart === "most-important" ? (
            <DataGrid
              disableSelectionOnClick
              rows={clients}
              columns={columns}
              // pageSize={20}
              // rowsPerPageOptions={[20]}
            />
          ) : (
            <DataGrid
              disableSelectionOnClick
              rows={archivedClients}
              columns={columnsArchived}
              // pageSize={20}
              // rowsPerPageOptions={[20]}
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
});

export { ClientTable };
